import { useState, useEffect, useCallback } from "react";

import api from "../../../../../api/api";
import { getCaseId, getClientId } from "../../../../../Utils/helper";

const useClientRelationship = () => {
  const [client_cases, set_client_cases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const clientId = getClientId();
  const currentCaseId = getCaseId();

  const fetchClientRelationship = useCallback(async () => {
    if (!clientId || !currentCaseId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const client_data = await api.get(
        `/api/client-page/client/${clientId}/case/${currentCaseId}/`
      );
      set_client_cases(client_data.data.client_cases);
    } catch (err) {
      console.error("Failed to fetch client Data:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [clientId, currentCaseId]);

  const refetch = useCallback(() => {
    fetchClientRelationship();
  }, [fetchClientRelationship]);

  useEffect(() => {
    fetchClientRelationship();
  }, [fetchClientRelationship]);

  return {
    client_cases,
    loading,
    error,
    refetch,
  };
};

export default useClientRelationship;
